(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkout-guard"] && !Shopify.designMode) return;
  try {
    (function () {
    // Shopify's hosted checkout: /checkout, /checkouts/..., and the cart
    // permalink /cart/<variant>:<qty>, which 302s straight into it. A
    // translated store puts a locale in front (/ar/checkout).
    const CHECKOUT_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:checkouts?(?:\/|$|\?)|cart\/\d+:\d+)/i;

    function codUrl() {
      // Read lazily: this bundle can execute before the marker is parsed.
      const holder = document.querySelector('[data-checkout-guard]');
      return (holder && holder.dataset.codUrl) || '/cart#commande';
    }

    function leadsToCheckout(href) {
      if (!href) return false;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        return false;
      }

      // Only this storefront. A payment provider or an app on its own domain
      // is not ours to reroute.
      if (url.origin !== window.location.origin) return false;

      return CHECKOUT_PATH.test(url.pathname);
    }

    function divert(event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = codUrl();
    }

    // Capture phase throughout, so a handler that stops propagation — an app's
    // own checkout button, say — cannot get past this first.
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target;
        if (!target || !target.closest) return;
        const link = target.closest('a[href]');
        if (!link || !leadsToCheckout(link.getAttribute('href'))) return;
        divert(event);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;
        if (!form || form.tagName !== 'FORM') return;

        // Shopify's stock cart form posts to /cart and is told apart only by
        // the name of the button that submitted it.
        const named = event.submitter && event.submitter.name === 'checkout';
        if (!named && !leadsToCheckout(form.getAttribute('action'))) return;
        divert(event);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["discount-state"] && !Shopify.designMode) return;
  try {
    if (!window.ForYouDiscount) {
    window.ForYouDiscount = {
      key: 'foryou:discount',

      read: function () {
        try {
          const stored = JSON.parse(sessionStorage.getItem(this.key));
          return stored && stored.code ? stored : null;
        } catch (error) {
          return null;
        }
      },

      save: function (discount) {
        try {
          sessionStorage.setItem(this.key, JSON.stringify(discount));
        } catch (error) {
          // Storage unavailable: the discount just won't survive navigation.
        }
      },

      clear: function () {
        try {
          sessionStorage.removeItem(this.key);
        } catch (error) {
          // Nothing to clean up.
        }
      },

      // The stored discount priced against the current cart, or null. A
      // changed subtotal means the cached amount is stale (product-scoped
      // codes depend on the cart lines), so the code is re-priced through
      // the API; a code that no longer applies is dropped.
      resolve: function (apiBase, currentSubtotal) {
        const stored = this.read();
        if (!stored) return Promise.resolve(null);
        if (Math.abs((stored.subtotal || 0) - currentSubtotal) < 0.005) {
          return Promise.resolve(stored);
        }
        if (this._inflight) return this._inflight;

        const self = this;
        this._inflight = (async function () {
          const root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            const cart = await fetch(root + 'cart.js').then((r) => r.json());
            const subtotal = (cart.items_subtotal_price || 0) / 100;
            const response = await fetch(
              (apiBase || '').replace(/\/+$/, '') + '/api/storefront/discounts/validate',
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  code: stored.code,
                  subtotal: subtotal,
                  line_items: (cart.items || []).map(function (item) {
                    return { variant_id: item.variant_id, quantity: item.quantity };
                  }),
                }),
              }
            );
            const data = await response.json().catch(function () {
              return {};
            });
            if (response.ok && data.valid) {
              const fresh = {
                code: data.code,
                amount: Number(data.amount) || 0,
                subtotal: subtotal,
              };
              self.save(fresh);
              return fresh;
            }
            if (response.status === 422) {
              self.clear();
              return null;
            }
          } catch (error) {
            // Network hiccup: show no discount but keep the stored code.
          }
          return null;
        })();
        this._inflight.finally(function () {
          self._inflight = null;
        });
        return this._inflight;
      },

      // Renders (or removes) the stored discount in one totals block.
      sync: function (foot) {
        const row = foot.querySelector('[data-discount-row]');
        const totalEl = foot.querySelector('[data-cart-total]');
        if (!row || !totalEl) return;
        const subtotal = Number(foot.dataset.subtotal) || 0;
        const shipping = Number(foot.dataset.shipping) || 0;
        const template = foot.dataset.moneyTemplate || '';
        const money = function (amount) {
          const value = amount.toFixed(2);
          return template.indexOf('[amount]') !== -1
            ? template.replace('[amount]', value)
            : value + ' MAD';
        };
        this.resolve(foot.dataset.apiBase, subtotal).then(function (discount) {
          if (discount) {
            const amount = Math.min(discount.amount, subtotal);
            const label = row.querySelector('[data-discount-label]');
            const amountEl = row.querySelector('[data-discount-amount]');
            if (label) {
              label.textContent = (row.dataset.rowLabel || '[code]').replace(
                '[code]',
                discount.code
              );
            }
            if (amountEl) amountEl.textContent = '−' + money(amount);
            row.hidden = false;
            totalEl.textContent = money(Math.max(subtotal + shipping - amount, 0));
          } else if (!row.hidden) {
            // Only restore a total this script previously overrode.
            row.hidden = true;
            totalEl.textContent = money(subtotal + shipping);
          }
        });
      },

      syncAll: function (scope) {
        const self = this;
        (scope || document).querySelectorAll('[data-cart-foot]').forEach(function (foot) {
          self.sync(foot);
        });
      },
    };

    const start = function () {
      window.ForYouDiscount.syncAll();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    // The drawer replaces its own markup after every cart change.
    document.addEventListener('cart:refreshed', function () {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) window.ForYouDiscount.syncAll(drawer);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-attribution"] && !Shopify.designMode) return;
  try {
    if (!window.ForYouMeta) {
    window.ForYouMeta = {
      // fb.1.1596403881668.1116446470 — Meta rejects anything shaped
      // differently, so a malformed cookie is dropped rather than sent.
      pattern: /^fb\.\d\.\d+\..+$/,

      cookie: function (name) {
        const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        if (!match) return null;

        let value;
        try {
          value = decodeURIComponent(match[1]);
        } catch (error) {
          // A cookie this malformed is not one Meta would have written.
          return null;
        }

        return this.pattern.test(value) ? value : null;
      },

      attribution: function () {
        return { fbp: this.cookie('_fbp'), fbc: this.cookie('_fbc') };
      },

      // Meta compares digests, so a field normalised differently from the way
      // Meta normalises it is not wrong — it is a hash of something else, and
      // never matches. fbq does the hashing itself, in the browser.
      identity: function (fields) {
        const text = function (value) {
          return String(value || '').trim();
        };

        // Entered as 06.. / 07.. locally; Meta matches on E.164 digits.
        let phone = text(fields.phone).replace(/[^\d]/g, '');
        if (phone.charAt(0) === '0') phone = '212' + phone.slice(1);

        const identity = {
          em: text(fields.email).toLowerCase(),
          ph: phone,
          fn: text(fields.first_name).toLowerCase(),
          ln: text(fields.last_name).toLowerCase(),
          // Bare lowercase letters, so the accented and unaccented spellings
          // of Tétouan collapse to the same string before either is hashed.
          ct: text(fields.city)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z]/g, ''),
          country: 'ma',
        };

        // A field left blank is omitted rather than sent as the hash of an
        // empty string, which would match every other blank in the dataset.
        Object.keys(identity).forEach(function (key) {
          if (!identity[key]) delete identity[key];
        });

        return identity;
      },

      // `order`: { orderId, value, currency, contents: [{id, quantity,
      // item_price}], identity }. Values are in the shop's currency, not
      // cents — the caller converts, because only it knows what it holds.
      publishPurchase: function (order) {
        const contents = order.contents || [];
        const orderId = String(order.orderId || '');

        const payload = {
          order_id: orderId,
          value: Number(Number(order.value || 0).toFixed(2)),
          currency:
            order.currency ||
            (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            'MAD',
          content_type: 'product',
          // Variant ids — the retailer id Shopify's Meta catalog feed uses.
          content_ids: contents.map(function (item) {
            return item.id;
          }),
          contents: contents,
          num_items: contents.reduce(function (sum, item) {
            return sum + item.quantity;
          }, 0),
          // The ForYou Api builds this same string for its Conversions API
          // copy. Meta collapses the pair into one counted Purchase on it.
          event_id: 'cod-purchase-' + (orderId || Date.now()),
          user_data: order.identity || {},
        };

        // Custom pixels are sandboxed and cannot see this scope, so the order
        // is handed to them as a custom event they can subscribe to.
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('cod_purchase', payload);
          }
        } catch (error) {
          // Tracking must never block the order confirmation.
        }

        return payload;
      },
    };
  }
  } catch(e) { console.error(e); }
})();

})();
